import React, { useState } from 'react';
import { UploadCloud, ShieldCheck, Loader2 } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';

export default function Onboarding() {
    const { getAuthHeaders } = useAuth();
    const navigate = useNavigate();
    const [file, setFile] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [successData, setSuccessData] = useState(null);

    const handleFileChange = (e) => {
        if (e.target.files && e.target.files[0]) {
            setFile(e.target.files[0]);
        }
    };

    const handleUpload = async () => {
        if (!file) return;
        setLoading(true);
        setError('');
        
        const formData = new FormData();
        formData.append('file', file);

        try {
            const headers = await getAuthHeaders();
            const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3001';
            
            const response = await fetch(`${API_URL}/api/onboarding/lock`, {
                method: 'POST',
                headers,
                body: formData
            });

            const result = await response.json();
            if (result.success) {
                setSuccessData(result.data);
            } else {
                setError(result.error || 'Error al procesar el documento.');
            }
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    const finishOnboarding = () => {
        // Recargar para que App.jsx vuelva a evaluar el estado
        window.location.href = '/bases';
    };

    return (
        <div style={{ maxWidth: '800px', margin: '4rem auto', textAlign: 'center' }}>
            <ShieldCheck size={64} style={{ color: '#10b981', margin: '0 auto 1.5rem' }} />
            <h1 style={{ fontSize: '2.5rem', fontWeight: 'bold', marginBottom: '1rem' }}>Paso de Seguridad Obligatorio</h1>
            
            {!successData ? (
                <>
                    <p style={{ fontSize: '1.25rem', color: 'hsl(var(--muted-foreground))', marginBottom: '3rem' }}>
                        Para proteger tu cuenta y evitar el subarriendo del servicio, El Gem necesita sellar tu identidad corporativa. Sube únicamente tu <strong>Constancia RNP</strong> (Registro Nacional de Proveedores).
                    </p>

                    <div className="card" style={{ padding: '3rem', border: '2px dashed hsl(var(--border))' }}>
                        <UploadCloud size={48} style={{ color: 'hsl(var(--primary))', margin: '0 auto 1rem' }} />
                        <h3>Sube tu Constancia Oficial aquí</h3>
                        <input 
                            type="file" 
                            accept=".pdf" 
                            onChange={handleFileChange} 
                            style={{ margin: '1rem auto', display: 'block' }}
                        />
                        
                        <button 
                            onClick={handleUpload}
                            disabled={!file || loading}
                            style={{ 
                                marginTop: '1.5rem', 
                                padding: '0.75rem 2rem', 
                                backgroundColor: !file || loading ? 'hsl(var(--muted))' : 'hsl(var(--primary))', 
                                color: 'white', 
                                border: 'none', 
                                borderRadius: 'var(--radius)', 
                                cursor: !file || loading ? 'not-allowed' : 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: '0.5rem',
                                margin: '1.5rem auto 0',
                                fontSize: '1.125rem'
                            }}
                        >
                            {loading ? <Loader2 className="animate-spin" /> : 'Sellar Identidad y Candado RUC'}
                        </button>
                        {error && <p style={{ color: '#ef4444', marginTop: '1rem', fontWeight: 'bold' }}>{error}</p>}
                    </div>
                </>
            ) : (
                <div className="card" style={{ padding: '3rem', backgroundColor: 'rgba(16, 185, 129, 0.1)', border: '2px solid #10b981' }}>
                    <h2 style={{ color: '#10b981', marginBottom: '1rem' }}>¡Candado RUC Activado!</h2>
                    <p style={{ fontSize: '1.125rem', marginBottom: '1.5rem' }}>El Gem ha blindado esta cuenta exclusivamente para:</p>
                    <div style={{ backgroundColor: 'white', padding: '1.5rem', borderRadius: 'var(--radius)', color: 'black', display: 'inline-block', textAlign: 'left' }}>
                        <p><strong>Razón Social:</strong> {successData.companyName}</p>
                        <p><strong>RUC:</strong> {successData.ruc}</p>
                    </div>
                    <p style={{ color: '#ef4444', marginTop: '1.5rem', fontSize: '0.875rem' }}>Atención: Cualquier documento de otra empresa subido a esta cuenta será bloqueado automáticamente.</p>
                    <button 
                        onClick={finishOnboarding}
                        style={{ marginTop: '2rem', padding: '1rem 3rem', backgroundColor: '#10b981', color: 'white', border: 'none', borderRadius: 'var(--radius)', cursor: 'pointer', fontSize: '1.125rem', fontWeight: 'bold' }}
                    >
                        Entrar a mi Taller de Expedientes
                    </button>
                </div>
            )}
        </div>
    );
}
